<template>
  <div class="head-board">
    <template  v-if="pics">
      <div class="head-board-content" v-for="(item, index) in pics" :key="index">
        <img @click="go(item.banner.url)" v-bind:src="item.banner.thumb_url" alt>
      </div>
    </template>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "HeadBoard",
  data() {
    return {};
  },
  props: ["banner"],
  computed: {
    pics() {
      return this.banner;
    }
  },
  methods: {
    go(index) {
      if(!index) {
        return;
      }
      if(!index.includes('jfbst.com')) {
        Dialog.confirm({
          message: "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服"
        }).then(() => {
          window.location.href = index;
        })
      } else {
        window.location.href = index;
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.head-board {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.head-board-content {
  width: 95%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
}
</style>
